import {useEffect, useState} from "react";
import styled from 'styled-components';

import {FormControl, Input, Textarea, useToast} from "@chakra-ui/react";
import {useParams} from "react-router-dom";
import useFeedback from "../../../utils/use_feedback";
import {useCommunitySettings, useReloadCommunity, useSaveSettings} from "../../../api/communities";
import {useSaveClicked} from "../../../store";
import FormContainer from "../../../components/form_container";
import {WhiteMain} from "../../../components/main";
import {FixedTopBar} from "../../../components/top_bar";

const SwitchHeading = styled.div``;

const BasicCommunitySettings = styled(({className}) => {
    const {community} = useParams();
    const {error, feedbackCh} = useFeedback();
    const [settings, setSettings] = useState({});
    useCommunitySettings(feedbackCh, community, setSettings);
    const set = (name) => (value) => setSettings((settings) => ({...settings, [name]: value}));

    const saveSettings = useSaveSettings(feedbackCh);
    const saveClicked = useSaveClicked();
    const reloadCommunity = useReloadCommunity(feedbackCh);
    const [saving, setSaving] = useState(false);
    const toast = useToast();
    useEffect(() => {
        (async () => {
            if (saveClicked) {
                if (!saving) {
                    setSaving(true);
                    toast({
                        title: `Saving...`,
                        status: 'info',
                        isClosable: true,
                    });
                    await saveSettings(community, settings);
                    await reloadCommunity([community]);
                    toast.closeAll();
                    toast({
                        title: `Saved settings.`,
                        status: 'success',
                        isClosable: true,
                    });
                    setSaving(false);
                }
            }
        })().then(() => {
        }, () => {
        });
    }, [saveClicked]);

    return (
        <>
            <FixedTopBar back title="Basic Information" border={false} save/>
            <WhiteMain className={className}>
                <FormContainer>

                    <SwitchHeading>Display Name</SwitchHeading>
                    <FormControl mb={4}>
                        <Input type="displayName"
                               value={settings.displayName}
                               maxLength="20"
                               required
                               autoComplete="off"
                               onChange={(ev) => set('displayName')(ev.currentTarget.value)}/>
                    </FormControl>

                    <SwitchHeading>Description</SwitchHeading>
                    <FormControl mb={4}>
                        <Textarea type="description"
                                  value={settings.description}
                                  rows={5}
                                  maxLength="255"
                                  required
                                  autoComplete="off"
                                  onChange={(ev) => set('description')(ev.currentTarget.value)}/>
                    </FormControl>

                    <SwitchHeading>Meta Tags</SwitchHeading>
                    <FormControl mb={4}>
                        <Textarea type="metaTags"
                                  value={settings.metaTags}
                                  rows={1}
                                  maxLength="255"
                                  required
                                  autoComplete="off"
                                  onChange={(ev) => set('metaTags')(ev.currentTarget.value)}/>
                    </FormControl>

                </FormContainer>
            </WhiteMain>
        </>
    );
})`
  ${FormContainer} {
    background-color: ${({theme}) => theme.color.name === 'dark' ? 'transparent' : theme.white_0};
    padding: 16px 20px;
  }
  ${SwitchHeading} {
    font-weight: 600;
    font-size: 15px;
    padding: 6px 0;
  }
`;

export default BasicCommunitySettings;
